import React from "react";
import { Empty, Button } from "antd";
import * as _ from "lodash";
import Blank from "../../../assets/img/empty.svg";
import CenterElement from "./CenterElement";
console.log({ Blank });
export default class NoData extends React.Component<{
  onReload?: () => void;
  title?: string | false;
  description?: string | JSX.Element;
  content?: JSX.Element;
  image?: string | JSX.Element;
  icon?: string;
}> {
  render() {
    return (
      <div>
        <br /> <br /> <br />
        <Empty
          image={_.get(this.props, "image", <Blank />)}
          description={
            this.props.title === false ? (
              ""
            ) : (
              <strong style={{ marginTop: "10px", fontSize: "large" }}>
                {_.get(this.props, "title", "No results were found!")}
              </strong>
            )
          }
        >
          <CenterElement>{this.props.content}</CenterElement>
          {!this.props.onReload ? null : (
            <Button onClick={this.props.onReload} type="primary">
              Reload
            </Button>
          )}
        </Empty>
      </div>
    );
  }
}
